// @ts-ignore
import saveFileLegacy from "@cirrus/legacy/app-common/utils/saveFile.es6"

export const saveFile = (data: ArrayBuffer, fileName: string) => {
  saveFileLegacy(data, { fileName })
}
